import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Stripe, StripeElements } from '@stripe/stripe-js';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StripeService {

  private stripe!: Stripe | null;
  private elements!: StripeElements;

  private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) {}

  createCheckoutSession(paymentInterval: 'yearly' | 'monthly'): Observable<any> {
    return this.http.post<any>(this.baseUrl + `/stripe/checkout`, { paymentInterval: paymentInterval });
  }

  createPaymentIntent(amount: number): Observable<{ clientSecret: string }> {
    return this.http.post<{ clientSecret: string }>(this.baseUrl + `/stripe/create-payment-intent`, { amount });
  }
}
